import React from 'react';
import { IconProps } from '../types';

export const ArchitectureIcon = ({ color }: IconProps) => (
    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.9896 28.9232V24.6667H19.9896V28.9232H17.9896Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.11 23.6667V29.9232L4.36713 29.9232L0.821777 26.7949L4.36713 23.6667H24.11ZM22.11 25.6667H5.12334L3.84466 26.7949L5.12334 27.9232H22.11V25.6667Z"
            fill={color}
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M25.9703 8.0638H30.2314V10.0638H25.9703V8.0638Z" fill={color} />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.9703 12.6862H29.4777V14.6862H25.9703V12.6862Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.9703 17.3125H30.2314V19.3125H25.9703V17.3125Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.9703 21.9349H29.4777V23.9349H25.9703V21.9349Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30.9998 4L27.7111 4V28.0004H30.9998V4ZM32.9998 2V30.0004H25.7111V2L32.9998 2Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.3332 2.19133L22.8162 7.97283L21.8503 9.72414L12.3332 4.47534L2.81615 9.72414L1.85028 7.97283L12.3332 2.19133Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.5151 13.3021H15.1515V19.7566H13.1515V15.3021H11.5151V19.7566H9.5151V13.3021Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.06043 10.3333V18.6061C6.06043 19.0583 6.42635 19.4242 6.87861 19.4242H17.7877C18.24 19.4242 18.6059 19.0583 18.6059 18.6061V10.3333H20.6059V18.6061C20.6059 20.1629 19.3445 21.4242 17.7877 21.4242H6.87861C5.32178 21.4242 4.06043 20.1629 4.06043 18.6061V10.3333H6.06043Z"
            fill={color}
        />
    </svg>
);
